import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../../components/Header';
import api from '../../api';

const EVENTOS = {
  login_ok: { l: 'Entrou', c: 'ok' },
  login_fail: { l: 'Login falhou', c: 'alerta' },
  senha_alterada: { l: 'Trocou a senha', c: 'ok' },
  senha_resetada: { l: 'Senha resetada', c: 'alerta' },
  vinculo_alterado: { l: 'Papel alterado', c: 'neutro' },
  cargo_mapeado: { l: 'Cargo mapeado', c: 'neutro' },
  permissao_negada: { l: 'Acesso negado', c: 'perigo' },
};
const MOTIVOS = {
  campos_vazios: 'campos vazios', cpf_invalido: 'CPF inválido', usuario_nao_encontrado: 'CPF não encontrado',
  senha_invalida: 'senha errada', senha_atual_invalida_na_troca: 'senha atual errada ao trocar',
};
const PAPEL = { colaborador: 'Colaborador', editor: 'Editor', ti: 'TI', rh: 'RH', admin: 'Admin' };

function descrever(e) {
  const d = e.detalhes || {};
  switch (e.evento) {
    case 'login_fail': return `${MOTIVOS[d.motivo] || d.motivo || ''}${d.senha_inicial ? ' (ainda na senha inicial)' : ''}`;
    case 'login_ok': return d.papel && d.papel !== 'colaborador' ? `como ${PAPEL[d.papel] || d.papel}` : '';
    case 'senha_alterada': return d.primeiro_acesso ? 'primeiro acesso' : '';
    case 'vinculo_alterado': return `${PAPEL[d.de] || d.de} → ${PAPEL[d.para] || d.para}`;
    case 'cargo_mapeado': return `${d.cargo}: ${d.de || 'sem perfil'} → ${d.para || 'sem perfil'}`;
    case 'permissao_negada': return `${d.rota || ''} (exigia ${d.exigia || '?'})`;
    default: return '';
  }
}
const fmt = (d) => new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

export default function Seguranca() {
  const [eventos, setEventos] = useState([]);
  const [evento, setEvento] = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    setCarregando(true);
    api.get('/acessos/log', { params: { evento, limite: 300 } })
      .then(({ data }) => setEventos(data.eventos))
      .catch(err => Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar o histórico.', 'error'))
      .finally(() => setCarregando(false));
  }, [evento]);

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 1100 }}>
        <Link to="/admin" className="doc-voltar"><i className="bi bi-arrow-left"></i> Administração</Link>
        <div className="adm-topo">
          <div>
            <h1>Histórico de segurança</h1>
            <p>Logins, senhas resetadas, papéis e cargos alterados — e quem fez. Mostra os 300 mais recentes.</p>
          </div>
        </div>

        <div className="adm-filtros">
          <select className="doc-input" style={{ maxWidth: 260 }} value={evento} onChange={e => setEvento(e.target.value)}>
            <option value="">Todos os eventos</option>
            {Object.entries(EVENTOS).map(([k, v]) => <option key={k} value={k}>{v.l}</option>)}
          </select>
        </div>

        {carregando ? <div>Carregando…</div> : (
          <div className="adm-tabela-wrap">
            <table className="adm-tabela">
              <thead><tr><th>Quando</th><th>Evento</th><th>Quem</th><th>Com quem</th><th>Detalhe</th><th>IP</th></tr></thead>
              <tbody>
                {eventos.map(e => {
                  const ev = EVENTOS[e.evento] || { l: e.evento, c: 'neutro' };
                  return (
                    <tr key={e.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{fmt(e.criado_em)}</td>
                      <td><span className={`adm-badge adm-badge--${ev.c}`}>{ev.l}</span></td>
                      <td>{e.usuario_nome || e.username || <span className="adm-sub">—</span>}</td>
                      <td>{e.alvo_nome || <span className="adm-sub">—</span>}</td>
                      <td>{descrever(e)}</td>
                      <td className="adm-sub">{e.ip || '—'}</td>
                    </tr>
                  );
                })}
                {eventos.length === 0 && <tr><td colSpan={6} className="adm-vazio">Nada registrado ainda.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </>
  );
}
